import { AddressState } from "./types";

const initialState: AddressState = {
      addressLoading: [],
      addressOk: [],
      addressFail: [],
      addresses: []
  };

  export default initialState;